import React from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { HeadContent, Title, IconArrow } from './mixins'
import { closeCart } from '../../../../../store/cart-v2/modal/actionsToDo'

const Component = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const icon = { name: 'icon-light-close' }
  const buttonOptions = { size: 'medium', type: 'link', variant: 'black' }
  return (
    <HeadContent>
      <Title>{t('Mi Carrito')}</Title>
      <IconArrow buttonoptions={buttonOptions} icon={icon} onClick={() => dispatch(closeCart())} />
    </HeadContent>
  )
}
export default Component
